import React from 'react';
import { SiChatbot } from "react-icons/si";

const ChatCircleIcon = ({ onClick }) => {
  return (
    <div onClick={onClick} style={styles.chatCircle}>
<SiChatbot />

    </div>
  );
};

const styles = {
  chatCircle: {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    width: '50px',
    height: '50px',
    backgroundColor: '#16A34A',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#fff',
    fontSize: '24px',
  },
};

export default ChatCircleIcon;
